if ( typeof CartForm !== 'function' ) {
  class CartForm extends HTMLElement {

    constructor() {
      super();
      this.ajaxifyCartItems();
    }

    ajaxifyCartItems() {
      this.form = this.querySelector('form');

      // Prevent default form submission
      if (this.form) {
        this.form.addEventListener('submit', e => {
          e.preventDefault();
        });
      }

      this.querySelectorAll('[data-js-cart-item]').forEach(item => {
        const remove = item.querySelector('.remove');
        if (remove) {
          remove.dataset.href = remove.getAttribute('href');
          remove.setAttribute('href', '');
          remove.addEventListener('click', e => {
            e.preventDefault();
            this.updateCartQty(item, 0);
          });
        }

        const qty = item.querySelector('.qty');
        if (qty) {
          // Handle input changes
          qty.addEventListener('input', debounce(e => {
  if (item && item.dataset.updating === 'true') return;

  e.preventDefault();
  e.target.blur();
  this.updateCartQty(item, parseInt(qty.value));
}, 500));

          // Handle Enter key press
          qty.addEventListener('keydown', e => {
            if (e.key === 'Enter') {
              e.preventDefault();
              this.updateCartQty(item, parseInt(qty.value));
            }
          });

          // Select text on click
          qty.addEventListener('click', e => {
            e.target.select();
          });
        }
      });
    }

    updateCartQty(item, newQty) {
      let alert = null;

      this.form = this.querySelector('form');
      if (!this.form) {
        return;
      }

      if (item) {
  item.dataset.updating = 'true';
}

this.form.classList.add('processing');
      if (this.querySelector('.alert')) {
        this.querySelector('.alert').remove();
      }

      const body = JSON.stringify({
        line: parseInt(item.dataset.line),
        quantity: newQty
      });

      fetch(KROWN.settings.routes.cart_change_url, {
  method: 'POST',
  credentials: 'include',
  headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
  body
})
        .then(response => response.json())
        .then(response => {
          if (response.status == 422) {
            // wrong stock logic alert
            alert = document.createElement('span');
            alert.classList.add('alert', 'alert--error');
            if (typeof response.description === 'string') {
              alert.innerHTML = response.description;
            } else {
              alert.innerHTML = response.message;
            }
          }
          return fetch('?section_id=helper-cart', {
  credentials: 'include',
  cache: 'no-store'
});
        })
        .then(response => response.text())
        .then(text => {
          const sectionInnerHTML = new DOMParser().parseFromString(text, 'text/html');
          const currentCartForm = document.getElementById('AjaxCartForm');
if (!currentCartForm) return;

// Pak de items uit de helper HTML, waar ze ook zitten
const newItems = sectionInnerHTML.querySelector('.cart__items');
const currentItems = currentCartForm.querySelector('.cart__items');

// Belangrijk: nooit meer de hele form vervangen (dat breekt je section.id scoped CSS)
if (newItems && currentItems) {
  currentItems.innerHTML = newItems.innerHTML;
} else {
  // Als helper-cart geen .cart__items teruggeeft, stop hier bewust.
  // Dit voorkomt dat je styling wegvalt.
  console.warn('[Cart] helper-cart response missing .cart__items, skip full replace to keep styling intact.');
  return;
}

          // Events opnieuw koppelen
          if (typeof currentCartForm.ajaxifyCartItems === 'function') {
            currentCartForm.ajaxifyCartItems();
          }

          // Nieuwe count & totaal uit de helper-cart halen
          const newCountEl = sectionInnerHTML.querySelector('[data-cart-count]');
const newTotalEl = sectionInnerHTML.querySelector('[data-cart-total]');

          const newCount = newCountEl ? newCountEl.textContent : null;
          const newTotal = newTotalEl ? newTotalEl.textContent : null;

          // Header-badge bijwerken
          if (newCount !== null) {
            document.querySelectorAll('[data-header-cart-count]').forEach(elm => {
              elm.textContent = newCount;
            });
          }
          if (newTotal !== null) {
            document.querySelectorAll('[data-header-cart-total]').forEach(elm => {
              elm.textContent = newTotal;
            });
          }

          // Hidden spans in de huidige form bijwerken
          if (newCount !== null) {
            const hiddenCount = currentCartForm.querySelector('[data-cart-count]');
            if (hiddenCount) {
              hiddenCount.textContent = newCount;
            }
          }

          if (newTotal !== null) {
            const hiddenTotal = currentCartForm.querySelector('[data-cart-total]');
            if (hiddenTotal) {
              hiddenTotal.textContent = newTotal;
            }
            // Subtotaal-tekst in jouw eigen blok updaten
            const subtotalTarget = document.querySelector('[data-cart-subtotal]');
            if (subtotalTarget) {
              subtotalTarget.textContent = newTotal;
            }
          }

          // 🟢 HIER: cart--empty class aan/uit zetten zodat hide-if-empty-cart blokken tonen/verdwijnen
          const formWrapper = currentCartForm.querySelector('.cart__form');
          if (formWrapper && newCount !== null) {
            const countNumber = parseInt(String(newCount).replace(/\D/g, ''), 10);
            if (!isNaN(countNumber) && countNumber > 0) {
              formWrapper.classList.remove('cart--empty');
            } else {
              formWrapper.classList.add('cart--empty');
            }
          }

          if (alert !== null) {
            this.form.prepend(alert);
          }

          // Optioneel: cart-subtotal container op cart-pagina zelf ook bijwerken
          const currentSubtotalContainer = document.getElementById('AjaxCartSubtotal');
          const newSubtotalContainer = sectionInnerHTML.getElementById('AjaxCartSubtotal');
          if (currentSubtotalContainer && newSubtotalContainer) {
            currentSubtotalContainer.innerHTML = newSubtotalContainer.innerHTML;
          }

          const event = new Event('cart-updated', { bubbles: true });

this.dispatchEvent(event);
document.dispatchEvent(event);
document.dispatchEvent(new Event('cart:updated'));

        })
        .catch(e => {
          console.log(e);
          let alert = document.createElement('span');
          alert.classList.add('alert', 'alert--error');
          alert.textContent = KROWN.settings.locales.cart_general_error;
          this.form.prepend(alert);
        })
        .finally(() => {
  if (item) {
    delete item.dataset.updating;
  }
  this.form.classList.remove('processing');
});
    }

  }

  if (typeof customElements.get('cart-form') == 'undefined') {
    customElements.define('cart-form', CartForm);
  }

}

if (typeof CartProductQuantity !== 'function') {

  class CartProductQuantity extends HTMLElement {
  constructor() {
    super();

    const minus = this.querySelector('.qty-minus');
    const plus = this.querySelector('.qty-plus');

    if (minus) {
      minus.setAttribute('type', 'button');
      minus.addEventListener('click', (e) => this.changeCartInput(e, -1), true);
    }

    if (plus) {
      plus.setAttribute('type', 'button');
      plus.addEventListener('click', (e) => this.changeCartInput(e, +1), true);
    }
  }

  changeCartInput(e, delta) {
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();

    const item = this.closest('[data-js-cart-item]');
    if (!item) return;

    const qtyInput = item.querySelector('.qty');
    if (!qtyInput) return;

    const current = parseInt(qtyInput.value, 10);
    const next = Math.max(0, (isNaN(current) ? 0 : current) + delta);

    qtyInput.value = String(next);

    const cartForm = document.getElementById('AjaxCartForm');
    if (cartForm && typeof cartForm.updateCartQty === 'function') {
      cartForm.updateCartQty(item, next);
    }
  }
}

  if (typeof customElements.get('cart-product-quantity') == 'undefined') {
    customElements.define('cart-product-quantity', CartProductQuantity);
  }

}

// method for apps to tap into and refresh the cart

if (!window.refreshCart) {

  window.refreshCart = () => {

    // Haal BEIDE sections op: drawer EN cart page
    Promise.all([
  fetch('?section_id=helper-cart', { credentials: 'include', cache: 'no-store' }).then(r => r.text()),
  fetch('?section_id=main-cart', { credentials: 'include', cache: 'no-store' }).then(r => r.text())
])
    .then(([drawerHTML, cartPageHTML]) => {
      
      // ========== UPDATE DRAWER ==========
      const sectionInnerHTML = new DOMParser().parseFromString(drawerHTML, 'text/html');
      const currentCartForm = document.getElementById('AjaxCartForm');
      if (!currentCartForm) return;

      const newItems = sectionInnerHTML.querySelector('.cart__items');
      const currentItems = currentCartForm.querySelector('.cart__items');

      if (newItems && currentItems) {
        currentItems.innerHTML = newItems.innerHTML;
      } else {
        console.warn('[Cart] helper-cart response missing .cart__items, skip full replace to keep styling intact.');
        return;
      }

      if (typeof currentCartForm.ajaxifyCartItems === 'function') {
        currentCartForm.ajaxifyCartItems();
      }

      const newCountEl = sectionInnerHTML.querySelector('[data-cart-count]');
      const newTotalEl = sectionInnerHTML.querySelector('[data-cart-total]');

      const newCount = newCountEl ? newCountEl.textContent : null;
      const newTotal = newTotalEl ? newTotalEl.textContent : null;

      if (newCount !== null) {
        document.querySelectorAll('[data-header-cart-count]').forEach(elm => {
          elm.textContent = newCount;
        });
        const hiddenCount = currentCartForm.querySelector('[data-cart-count]');
        if (hiddenCount) {
          hiddenCount.textContent = newCount;
        }
      }

      if (newTotal !== null) {
        document.querySelectorAll('[data-header-cart-total]').forEach(elm => {
          elm.textContent = newTotal;
        });
        const hiddenTotal = currentCartForm.querySelector('[data-cart-total]');
        if (hiddenTotal) {
          hiddenTotal.textContent = newTotal;
        }
        const subtotalTarget = document.querySelector('[data-cart-subtotal]');
        if (subtotalTarget) {
          subtotalTarget.textContent = newTotal;
        }
      }

      // Cart empty class
      const formWrapper = currentCartForm.querySelector('.cart__form');
      if (formWrapper && newCount !== null) {
        const countNumber = parseInt(String(newCount).replace(/\D/g, ''), 10);
        if (!isNaN(countNumber) && countNumber > 0) {
          formWrapper.classList.remove('cart--empty');
        } else {
          formWrapper.classList.add('cart--empty');
        }
      }

      const currentSubtotalContainer = document.getElementById('AjaxCartSubtotal');
      const newSubtotalContainer = sectionInnerHTML.getElementById('AjaxCartSubtotal');
      if (currentSubtotalContainer && newSubtotalContainer) {
        currentSubtotalContainer.innerHTML = newSubtotalContainer.innerHTML;
      }

      if (document.querySelector('[data-js-site-cart-sidebar]')) {
        document.querySelector('[data-js-site-cart-sidebar]').show();
      }

      if (document.querySelector('cart-recommendations')) {
        document.querySelector('cart-recommendations').innerHTML = '';
        document.querySelector('cart-recommendations').generateRecommendations();
      }

      // ========== UPDATE CART PAGE ==========
      const cartPageDOM = new DOMParser().parseFromString(cartPageHTML, 'text/html');
      const currentCartPage = document.querySelector('#main-cart .cart__items');
      
      if (currentCartPage) {
        const newCartPageItems = cartPageDOM.querySelector('.cart__items');
        if (newCartPageItems) {
          currentCartPage.innerHTML = newCartPageItems.innerHTML;
          console.log('[Cart] Cart page synchronized');
        }
      }

      // Update cart page subtotal
      const currentCartPageSubtotal = document.querySelector('#main-cart [data-cart-subtotal]');
      const newCartPageSubtotal = cartPageDOM.querySelector('[data-cart-subtotal]');
      if (currentCartPageSubtotal && newCartPageSubtotal) {
        currentCartPageSubtotal.textContent = newCartPageSubtotal.textContent;
      }

    })
    .catch(err => console.error('[Cart] Refresh error:', err));

  };

}

if (!customElements.get('cart-note')) {
  customElements.define(
    'cart-note',
    class CartNote extends HTMLElement {
      constructor() {
        super();
        this._pendingTimer = null;
        this._inflightController = null;
        // Geen per-toetsaanslag auto-save: dat veroorzaakte overlappende
        // /cart/update.js requests die door out-of-order verwerking een
        // oudere, kortere note over de definitieve tekst heen schreven
        // (afgekapte opmerkingen in de admin). De note wordt nu alleen bij
        // checkout opgeslagen via flushPendingSave().
      }

      _saveNote(value) {
        // Abort any in-flight save so a slower older request can't overwrite this newer value.
        if (this._inflightController) this._inflightController.abort();
        this._inflightController = new AbortController();
        const controller = this._inflightController;

        return fetch(`${KROWN.settings.routes.cart_update_url}`, {
          method: 'POST',
          credentials: 'include',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/javascript' },
          body: JSON.stringify({ note: value }),
          signal: controller.signal,
          keepalive: true
        }).catch((err) => {
          if (err && err.name === 'AbortError') return;
          throw err;
        }).finally(() => {
          if (this._inflightController === controller) this._inflightController = null;
        });
      }

      // Called before navigating to checkout so the final value reaches Shopify
      // and no older in-flight save can overwrite it.
      flushPendingSave() {
        if (this._pendingTimer) {
          clearTimeout(this._pendingTimer);
          this._pendingTimer = null;
        }
        const textarea = this.querySelector('textarea');
        if (!textarea) return Promise.resolve();
        return this._saveNote(textarea.value);
      }
    }
  );
}
